import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/slider/slider.js';
      import {ObcSliderValueEvent, ObcSliderVariant} from '@oicl/openbridge-webcomponents/dist/components/slider/slider.js';

      export interface Props {
     value?: number;
     min?: number;
     max?: number;
     step?: number | undefined;
     stepClick?: number;
     variant?: ObcSliderVariant;
     hasLeftIcon?: boolean;
     hasRightIcon?: boolean;
     allowSeeking?: boolean;
     seekingSpeed?: number;
     disabled?: boolean
   }

      
  
      export type {ObcSliderValueEvent, ObcSliderVariant} from '@oicl/openbridge-webcomponents/dist/components/slider/slider.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcSlider',
  props: {
    value: {},
    min: {},
    max: {},
    step: {},
    stepClick: {},
    variant: {},
    hasLeftIcon: { type: Boolean },
    hasRightIcon: { type: Boolean },
    allowSeeking: { type: Boolean },
    seekingSpeed: {},
    disabled: { type: Boolean }
  },
  emits: ["value"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onValue: (event: ObcSliderValueEvent) => emit('value', event as ObcSliderValueEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-slider',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})